export default "__VITE_ASSET__23f2e5f5__"